import { render, staticRenderFns } from "./Companys.vue?vue&type=template&id=cac85a0a&"
import script from "./Companys.vue?vue&type=script&lang=js&"
export * from "./Companys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports